import { createSlice } from '@reduxjs/toolkit';

type ChatroomSearchState = {
  loading: boolean;
  message: string;
  currentChatroom: any;
  readMessageId: number;
  chatMessageList: any;
  chatroomMemberList: any;
  chatroomKindList: any;
  messageSearchText: string;
  editedMessageId: number;
  editedMessageBody: string;
  deletedMessageId: number;
  deletedMessageBody: string;
  deletedMessageFileFlg: string;
  exportSignedUrl: string;
  noticeRoomList: any;
  fileListMode: boolean;
  fileList: any;
  searchKindRoom: any;
  otherMemberUserList: any;
  modalClose: boolean;
  roomDetail: any;
  registerChatroom: boolean;
};

const initialState: ChatroomSearchState = {
  loading: false,
  message: '',
  currentChatroom: {},
  readMessageId: 0,
  chatMessageList: [],
  chatroomMemberList: [],
  chatroomKindList: [],
  messageSearchText: '',
  editedMessageId: 0,
  editedMessageBody: '',
  deletedMessageId: 0,
  deletedMessageBody: '',
  deletedMessageFileFlg: '',
  exportSignedUrl: '',
  noticeRoomList: [],
  fileListMode: false,
  fileList: [],
  searchKindRoom: [],
  otherMemberUserList: [],
  modalClose: false,
  roomDetail: {},
  registerChatroom: false,
};

export const chatroomSlice = createSlice({
  name: 'chatroom',
  initialState,
  reducers: {
    setChatroom: (state, action) => {
      state.currentChatroom = action.payload;
    },
    getMessage: (state, action) => {
      state.loading = true;
    },
    getMessageSuccess: (state, action) => {
      state.chatMessageList = action.payload;
      state.loading = false;
    },
    getMessageFailure: (state, action) => {
      state.loading = action.payload.loading;
      // state.message = action.payload.message;
    },
    setChatroomReadStatus: (state, action) => {
      state.readMessageId = action.payload;
    },
    setChatroomKindList: (state, action) => {
      state.chatroomKindList = action.payload;
    },
    getChatroomMember: (state, action) => {
      state.loading = true;
    },
    getChatroomMemberSuccess: (state, action) => {
      state.chatroomMemberList = action.payload;
      state.loading = false;
    },
    getChatroomMemberFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    setMessageSearchText: (state, action) => {
      state.messageSearchText = action.payload;
    },
    setEditedMessage: (state, action) => {
      state.editedMessageId = action.payload.MESSAGE_ID;
      state.editedMessageBody = action.payload.MESSAGE_BODY;
    },
    setDeletedMessage: (state, action) => {
      state.deletedMessageId = action.payload.MESSAGE_ID;
      state.deletedMessageBody = action.payload.MESSAGE_BODY;
      if (action.payload.FILE_FLG) {
        state.deletedMessageFileFlg = action.payload.FILE_FLG;
      } else {
        state.deletedMessageFileFlg = initialState.deletedMessageFileFlg;
      }
    },
    updateMessage: (state, action) => {
      state.loading = true;
    },
    updateMessageSuccess: (state, action) => {
      state.chatMessageList.forEach((item: { EDIT_FLG: string; MESSAGE_ID: any; MESSAGE_BODY: any }) => {
        if (item.MESSAGE_ID === action.payload.MESSAGE_ID) {
          item.MESSAGE_BODY = action.payload.MESSAGE_BODY;
          item.EDIT_FLG = '1';
        }
      });
      state.loading = false;
    },
    updateMessageFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    deleteMessage: (state, action) => {
      state.loading = true;
    },
    deleteMessageSuccess: (state, action) => {
      const index = state.chatMessageList.findIndex(
        (item: { MESSAGE_ID: any }) => item.MESSAGE_ID === action.payload.MESSAGE_ID
      );
      state.chatMessageList.splice(index, 1);
      state.loading = false;
    },
    deleteMessageFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    registerChatroomAuto: (state, action) => {
      state.loading = true;
    },
    registerChatroomAutoSuccess: (state, action) => {
      state.registerChatroom = action.payload;
    },
    registerChatroomAutoFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    updateChatroom: (state, action) => {
      state.loading = true;
    },
    updateChatroomSuccess: (state, action) => {
      state.modalClose = true;
      state.loading = false;
    },
    updateChatroomFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    setModalClose: (state) => {
      state.modalClose = false;
    },
    registerFile: (state, action) => {
      state.loading = true;
    },
    registerFileSuccess: (state, action) => {
      state.chatMessageList = action.payload;
      state.loading = false;
    },
    registerFileFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    registerNoticeMessage: (state, action) => {
      state.loading = true;
    },
    registerNoticeMessageSuccess: (state, action) => {
      state.chatMessageList = action.payload;
      state.loading = false;
    },
    registerNoticeMessageFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    getNotice: (state, action) => {
      state.loading = true;
    },
    getNoticeSuccess: (state, action) => {
      state.noticeRoomList = action.payload;
      state.loading = false;
    },
    getNoticeFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    setFileListMode: (state, action) => {
      if (action.payload === 'change') {
        state.fileListMode = !state.fileListMode;
      } else {
        state.fileListMode = action.payload;
      }
    },
    getChatroomFileList: (state, action) => {
      state.loading = true;
    },
    getChatroomFileListSuccess: (state, action) => {
      state.fileList = action.payload;
      state.loading = false;
    },
    getChatroomFileListFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    getChatroomByKind: (state, action) => {
      state.loading = true;
    },
    getChatroomByKindSuccess: (state, action) => {
      state.searchKindRoom = action.payload;
      state.loading = false;
    },
    getChatroomByKindFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    exportChatMessage: (state, action) => {
      state.loading = true;
    },
    exportChatMessageSuccess: (state, action) => {
      state.exportSignedUrl = action.payload.data.signedUrl;
      state.loading = false;
    },
    exportChatMessageFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    clearExportSignedUrl: (state) => {
      state.exportSignedUrl = '';
    },
    getUserMastList: (state, action) => {
      state.loading = true;
    },
    getUserMastListSuccess: (state, action) => {
      state.otherMemberUserList = action.payload;
      state.loading = false;
    },
    getUserMastListFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    getChatroomReadStatus: (state, action) => {
      state.loading = true;
    },
    getChatroomReadStatusSuccess: (state, action) => {
      // state.chatroomReadId = action.payload;
      state.loading = false;
    },
    getChatroomReadStatusFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    deleteFile: (state, action) => {
      state.loading = true;
    },
    deleteFileSuccess: (state, action) => {
      state.loading = false;
    },
    deleteFileFailure: (state, action) => {
      state.loading = action.payload.loading;
      state.message = action.payload.message;
    },
    clearChatroom: (state) => {
      state.chatroomMemberList = [];
      state.currentChatroom = {};
      state.chatMessageList = [];
    },
    cleanData: (state) => {
      return {
        ...initialState,
      };
    },
  },
});

export const {
  setChatroom,
  getMessage,
  getMessageSuccess,
  getMessageFailure,
  setChatroomReadStatus,
  setChatroomKindList,
  getChatroomMember,
  getChatroomMemberSuccess,
  getChatroomMemberFailure,
  setMessageSearchText,
  setEditedMessage,
  setDeletedMessage,
  updateMessage,
  updateMessageSuccess,
  updateMessageFailure,
  deleteMessage,
  deleteMessageSuccess,
  deleteMessageFailure,
  registerChatroomAuto,
  registerChatroomAutoSuccess,
  registerChatroomAutoFailure,
  updateChatroom,
  updateChatroomSuccess,
  updateChatroomFailure,
  registerFile,
  registerFileSuccess,
  registerFileFailure,
  registerNoticeMessage,
  registerNoticeMessageSuccess,
  registerNoticeMessageFailure,
  getNotice,
  getNoticeSuccess,
  getNoticeFailure,
  setFileListMode,
  getChatroomFileList,
  getChatroomFileListSuccess,
  getChatroomFileListFailure,
  getChatroomByKind,
  getChatroomByKindSuccess,
  getChatroomByKindFailure,
  exportChatMessage,
  exportChatMessageSuccess,
  exportChatMessageFailure,
  clearExportSignedUrl,
  getUserMastList,
  getUserMastListSuccess,
  getUserMastListFailure,
  setModalClose,
  getChatroomReadStatus,
  getChatroomReadStatusSuccess,
  getChatroomReadStatusFailure,
  deleteFile,
  deleteFileSuccess,
  deleteFileFailure,
  clearChatroom,
  cleanData,
} = chatroomSlice.actions;

export default chatroomSlice.reducer;
